var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 17H12.9V10.425H11.1V17ZM12 9.22495C12.3333 9.22495 12.6042 9.11662 12.8125 8.89995C13.0208 8.68328 13.125 8.40828 13.125 8.07495C13.125 7.75828 13.0208 7.49162 12.8125 7.27495C12.6042 7.05828 12.3333 6.94995 12 6.94995C11.6667 6.94995 11.3958 7.05828 11.1875 7.27495C10.9792 7.49162 10.875 7.75828 10.875 8.07495C10.875 8.40828 10.9792 8.68328 11.1875 8.89995C11.3958 9.11662 11.6667 9.22495 12 9.22495ZM12 22.625C9.48333 21.9916 7.41667 20.5541 5.8 18.3125C4.18333 16.0708 3.375 13.6083 3.375 10.925V4.54995L12 1.32495L20.65 4.54995V10.925C20.65 13.6083 19.8375 16.0708 18.2125 18.3125C16.5875 20.5541 14.5167 21.9916 12 22.625ZM12 20.225C13.8333 19.5083 15.3375 18.3083 16.5125 16.625C17.6875 14.9416 18.275 13.0416 18.275 10.925V6.19995L12 3.82495L5.725 6.19995V10.925C5.725 13.0416 6.3125 14.9416 7.4875 16.625C8.6625 18.3083 10.1667 19.5083 12 20.225Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacy);
export default __webpack_public_path__ + "static/media/icon-privacy.8f38db9973fa05f86d99d3e8c1d894ea.svg";
export { ForwardRef as ReactComponent };